
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getLegalPageSettings, getBrandingSettings, getStudioByOwner } from '../../services/dataService';
import { LegalPageSettings, BrandingSettings } from '../../types';
import { useTenant } from '../../context/TenantContext';

interface GlobalFooterProps {
    hasBottomNav?: boolean;
}

export const GlobalFooter: React.FC<GlobalFooterProps> = ({ hasBottomNav = false }) => {
    const { tenant } = useTenant();
    const [legal, setLegal] = useState<LegalPageSettings>({});
    const [branding, setBranding] = useState<BrandingSettings>({ appTitle: 'Janoobi Studios Platform' });

    useEffect(() => {
        const fetch = async () => {
            try {
                const l = await getLegalPageSettings(tenant?.id);
                setLegal(l);

                let b: BrandingSettings = { appTitle: 'Janoobi Studios Platform' };
                if (tenant && tenant.ownerId) {
                     const studio = await getStudioByOwner(tenant.ownerId);
                     const br = await getBrandingSettings();
                     if (studio) {
                         b = { 
                             ...br,
                             appTitle: studio.name || br?.appTitle || tenant.name, 
                             logoUrl: studio.logoUrl || br?.logoUrl, 
                             faviconUrl: studio.faviconUrl || br?.faviconUrl || studio.logoUrl || br?.logoUrl
                         };
                     } else {
                         b = { appTitle: tenant.name };
                     }
                } else {
                    b = await getBrandingSettings();
                }
                setBranding(b);
            } catch(e) {}
        };
        fetch();
    }, [tenant]);

    const LegalLink = ({ to, label, url }: { to: string, label: string, url?: string }) => {
        if (url) {
            return <a href={url} target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors underline decoration-white/20 underline-offset-4">{label}</a>;
        }
        return <Link to={to} className="hover:text-white transition-colors underline decoration-white/20 underline-offset-4">{label}</Link>;
    };

    return (
        <footer className={`border-t border-white/10 py-12 ${hasBottomNav ? 'pb-32' : ''} md:pb-12 text-center bg-black relative z-10 no-print`}>
            <div className="flex justify-center flex-wrap gap-6 mb-6 text-xs font-bold uppercase tracking-widest text-neutral-400">
                <LegalLink to="/privacy" label="Privacy Policy" url={legal.privacyUrl} />
                <LegalLink to="/terms" label="Terms of Service" url={legal.termsUrl} />
                <LegalLink to="/refund-policy" label="Refund Policy" url={legal.refundUrl} />
                <LegalLink to="/eula" label="EULA" url={legal.eulaUrl} />
            </div>
            <p className="text-[10px] text-neutral-600 font-mono uppercase tracking-widest mb-4">
                © {new Date().getFullYear()} {branding.appTitle}. All Rights Reserved.
            </p>
        </footer>
    );
};
